import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateForUserList = createSelector(
  [
    (store: RootState) => store.templateList.templatesForUser,
    (store: RootState) => store.templateList.userTemplateSearchText,
    (store: RootState) => store.templateList.templatesAssignedToUser,
  ],
  (templates, searchText, assignedTemplates ) => templates.filter(
    ({ name, id }) => {
      if (
        searchText
        && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
      ) {
        return false;
      }
      if (assignedTemplates
        && assignedTemplates.find(({form})=> form === id)) {
          return false
        }
      return true;
    })
);